import React from 'react'
import {Icon} from '@chakra-ui/react'

const ChevronRightHeaderIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" {...props}>
            <path
                id="arrow"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.19463 2C5.27143 2 5.34823 2.0294 5.40702 2.0876L11.1118 7.78753C11.1682 7.84393 11.2 7.92013 11.2 7.99993C11.2 8.07972 11.1682 8.15592 11.1118 8.21232L5.40702 13.9123C5.28942 14.0292 5.09983 14.0292 4.98223 13.9123C4.86523 13.7947 4.86523 13.6051 4.98223 13.4875L10.4758 7.99993L4.98223 2.51239C4.86523 2.3948 4.86523 2.2052 4.98223 2.0876C5.04103 2.0294 5.11783 2 5.19463 2Z"
                fill="white"
            />
        </Icon>
    )
}

export default ChevronRightHeaderIcon
